module.exports = __webpack_public_path__ + "img/74.9ec6cf72.jpg";